import styled from 'styled-components';

import { floorGameColor as color, styledTypography } from '@pkg/primitives';

import { tokens } from '../../../../tokens';

export const StyledKeywordMarquee = styled.div`
    display: flex;
    gap: ${tokens.incoming.keywordMarquee.gap}px;
    align-items: center;
`;

export const Column = styled.div`
    flex: 0 0 auto;
`;

export const MarqueeArrowsWrapper = styled.div`
    height: ${tokens.incoming.keywordMarquee.height}px;
    color: ${color.white};
`;

export const Label = styled.p`
    ${styledTypography.tuskerBase};
    font-size: ${tokens.incoming.keywordMarquee.fontSize}px;
    font-weight: 400;
    letter-spacing: -0.02em;
    text-transform: uppercase;
    color: ${color.white};
`;
